export default __webpack_public_path__ + "static/media/louvre_rooftops_detail.c49b443f.jpg";